import React, { PropsWithChildren, useCallback } from "react"
import { TranslationsProvider } from "@cirrus/core/i18n/provider"
import { useTranslationsContext } from "./context"

export const WithI18n = ({ children }: PropsWithChildren) => {
	const { language, translations } = useTranslationsContext()

	const i18n = useCallback((key: string) => {
		try {
			const parts = key.split(":")
			const result = translations?.[language]?.[parts[0]][parts[1]]
			return !result?.trim?.()?.length ? key : result
		} catch (error) {
			console.warn(error)
			return key
		}
	}, [translations, language])

	return <TranslationsProvider translations={{ i18n }}>
		{children}
	</TranslationsProvider>
}
